// 智慧增值
import Log from "../view/log";
import ValueAddedNav from "../view/ValueAddedService/ValueAddedNav";
import ServiceOverView from "../view/ValueAddedService/ServiceOverView/ServiceOverView";
import ServiceCategoryManage from "../view/ValueAddedService/ServiceCategory/ServiceCategoryManage";
import ServiceCategoryAdd from "../view/ValueAddedService/ServiceCategory/ServiceCategoryAdd";
import ServiceCategoryModify from "../view/ValueAddedService/ServiceCategory/ServiceCategoryModify";
import ServiceProviderManage from "../view/ValueAddedService/ServiceProvider/ServiceProviderManage";
import ServiceProviderAdd from "../view/ValueAddedService/ServiceProvider/ServiceProviderAdd";
import ServiceProviderModify from "../view/ValueAddedService/ServiceProvider/ServiceProviderModify";
import ServiceConsumptionRecord from "../view/ValueAddedService/ServiceConsumptionRecord/ServiceConsumptionRecord";
import ServiceVenueRecord from "../view/ValueAddedService/ServiceVenueRecord/ServiceVenueRecord";

export default [
  /* 智慧增值 */
  {
    path: "/service_over_view",
    name: "service-over-view",
    components: {
      default: ValueAddedNav,
      a: ServiceOverView
    }
  },
  {
    path: "/service_category_manage",
    name: "service-category-manage",
    components: {
      default: ValueAddedNav,
      a: ServiceCategoryManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/service_category_add",
    name: "service-category-add",
    components: {
      default: ValueAddedNav,
      a: ServiceCategoryAdd
    }
  },
  {
    path: "/service_category_modify/:id",
    name: "service-category-modify",
    components: {
      default: ValueAddedNav,
      a: ServiceCategoryModify
    }
  },
  {
    path: "/service_provider_manage",
    name: "service-provider-manage",
    components: {
      default: ValueAddedNav,
      a: ServiceProviderManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/service_provider_add",
    name: "service-provider-add",
    components: {
      default: ValueAddedNav,
      a: ServiceProviderAdd
    }
  },
  {
    path: "/service_provider_modify/:id",
    name: "service-provider-modify",
    components: {
      default: ValueAddedNav,
      a: ServiceProviderModify
    }
  },
  {
    path: "/service_consumption_record",
    name: "service-consumption-record",
    components: {
      default: ValueAddedNav,
      a: ServiceConsumptionRecord
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/service_venue_record",
    name: "service-venue-record",
    components: {
      default: ValueAddedNav,
      a: ServiceVenueRecord
    },
    meta: {
      keepAlive: true
    }
  },
  /* 智慧增值 */
  // 智慧服务操作日志
  {
    path: "/value_added_log",
    name: "value-added-log",
    components: {
      default: ValueAddedNav,
      a: Log
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/ValueAddedService.js